






























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ajax from "@/lib/ajax";

@Component({
  components: {},
})
export default class UpdateTravel extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) orderId: number;

  seletedList: [];
  list: Array<any> = new Array<any>();
  async login() {
    (this.$refs.loginForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$emit("login-success");
        this.$emit("input", false);
      }
    });
  }
  mounted() {}
  async save() {}
  cancel() {
    (this.$refs.loginForm as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      ajax
        .get("/api/services/app/OrderTeeDate/GetAll", {
          params: {
            orderId: this.orderId,
          },
        })
        .then((res) => {
          if (res && res.data && res.data.result) {
            this.list = res.data.result.items;
          }
        });
    }
  }
  rules = {
    userNameOrEmailAddress: [
      {
        required: true,
        message: this.L("UserNameRequired"),
        trigger: "blur",
      },
    ],
    password: [
      {
        required: true,
        message: this.L("PasswordRequired"),
        trigger: "blur",
      },
    ],
  };
}
